import React from "react";
import ReactWizard from "../Wizard";
import BasicInfo from "./components/InventoryFormComponents/BasicInformation";
import DetailedInfo from "./components/InventoryFormComponents/DetailedInformation";

const STEPS = [
  {
    stepName: "Basic",
    component: BasicInfo,
  },
  {
    stepName: "Detailed",
    component: DetailedInfo,
  },
];

const InventoryForm = (props) => {
  return (
    <ReactWizard
      steps={STEPS}
      title={props.isEdit ? "Edit Inventory" : "Add Inventory"}
      validate
      finishButtonClick={(data) => props.onFormSubmit(data)}
    />
  );
};

export default InventoryForm;
